import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
const Hr = () => /* @__PURE__ */ jsx(
  Box,
  {
    sx: {
      borderBottom: "1px solid",
      borderColor: (t) => t.palette.border.base.elevation1,
      width: "100%"
    }
  }
);
export {
  Hr
};
//# sourceMappingURL=Hr.js.map
